import { render, staticRenderFns } from "./SingleItem.vue?vue&type=template&id=6695a41a&scoped=true"
import script from "./SingleItem.vue?vue&type=script&lang=js"
export * from "./SingleItem.vue?vue&type=script&lang=js"
import style0 from "./SingleItem.vue?vue&type=style&index=0&id=6695a41a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6695a41a",
  null
  
)

export default component.exports